import { DIMENSIONS } from "utils/Dimensions";
import moment from "moment";

export function getFormattedCommentsArray(params, comments, isRowDetailView = false) {
  let commentsArray = [];
  if (comments && Array.isArray(comments)) {
    for (let i = comments.length - 1; i >= 0; i--) {
      let commentObject = comments[i];
      const { description, created_at, created_by_name } = commentObject;
      const istDate = new Date(created_at);
      const finalDate = params.store.convertIstToCurrentTimeZone(istDate);
      const formattedDate = `<span style="font-size: 9px;">${moment(finalDate).fromNow()}</span>`;
      const indexStyling = `<div style=" display:inline-block;vertical-align: text-top; background-color: #3f51b5; color: white; border-radius: 50%; width: ${i + 1 >= 100 ? '20px' : i + 1 >= 10 ? '17px' : '15px'}; height: ${i + 1 >= 100 ? '20px' : i + 1 >= 10 ? '17px' : '15px'}; text-align: center; line-height: ${i + 1 >= 100 ? '20px' : i + 1 >= 10 ? '17px' : '15px'}; margin-right: 5px; font-size: 9px">${i + 1}</div>`;
      const createdByAndDate = `<span style="padding: 9px; border-radius: 20px; text-align: center; display: inline-block; align-items: center; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; background-color: #e7e7e7; color: #4e4e4e; line-height: 0px; ">${created_by_name} ${formattedDate}</span>`;
      const formattedComment = `<div style="display: inline-block; vertical-align: top;">${indexStyling}</div><div style="display: inline-block; max-width: calc(100% - ${isRowDetailView ? '50' : '30'}px); vertical-align: top; margin-bottom: 5px; color: #3f51b5; max-height: 95px; overflow-y: auto">${description}</div><span style="display: flex; align-items: center; max-width: 95%;">${createdByAndDate}</span>`;
      commentsArray.push(formattedComment);
    }
  }
  return commentsArray;
}

export default function CommentsIdColumnRenderer(params, isRowDetailView = false) {
  const commentsArray = getFormattedCommentsArray(params, params?.data?.comments) ?? [];

  if(params.colDef.colId === 'userEvents') return null;
  var numberOfRows = 1, display = "-webkit-box";
  switch(params.node.rowHeight) {
    case DIMENSIONS.cell_height_medium:
      numberOfRows = 2;
      break;
    case DIMENSIONS.cell_height_tall:
      numberOfRows = 4;
      break;
    case DIMENSIONS.cell_height_extra_tall:
      numberOfRows = 6;
      break;
    default:    
      numberOfRows = 1;
      display = "";
  }
  const widthOfCell = isNaN(Number(params.colDef.width)) ? Number(params.column.actualWidth) : Number(params.colDef.width);
  const x = params.eGridCell;
  x.addEventListener("focus",function(e){
    const src= e.target;
    const srcTop = src.getBoundingClientRect().top;
    params.store.currentCommenteGridCell = e.target;
    if (window.innerHeight - srcTop < 198) {
      if ((params.node.rowIndex +1) * params.node.rowHeight < 150) {
          let newBottom = 150 - (params.node.rowIndex+1) * params.node.rowHeight;
          src.style.position = "absolute";
          src.style.bottom = `-${newBottom + 4}px`;
      } else {
          src.style.position = "absolute";
          src.style.bottom = "0px";
      }
    }
    if (
      window.navigator.vendor.includes("Apple") &&
      window.navigator.userAgent.includes("Safari")
    ) {
      if (params.node.rowHeight <= DIMENSIONS.cell_height_compact) {
        let multiLineCell = document.querySelector(".ag-cell-focus .multiLineCell");
        let multiLineCompactCellValueContainer = document.querySelector(
          ".ag-cell-focus .multiLineCompactCellValueContainer"
        );
        multiLineCell?.style.setProperty("--custom-white-space", "pre-line");
        multiLineCompactCellValueContainer?.style.setProperty(
          "--custom-white-space",
          "pre-line"
        );
        multiLineCompactCellValueContainer?.style.setProperty(
          "--custom-margin-top",
          "5px"
        );
        return;
      } else if (params.node.rowHeight > DIMENSIONS.cell_height_compact) {
        let multiLineCell = document.querySelector(".ag-cell-focus .multiLineCell");
        let multiLineCellValueContainer = document.querySelector(
          ".ag-cell-focus .multiLineCellValueContainer"
        );
        multiLineCell?.style.setProperty("--custom-white-space", "pre-line");
        multiLineCellValueContainer?.style.setProperty(
          "--custom-white-space",
          "pre-line"
        );
        multiLineCellValueContainer?.style.setProperty(
          "--custom-margin-top",
          "4px"
        );
        return;
      }
    }
  });
  x.addEventListener("click", function(e) {
    if(params.store.isGridCellEditing){
      return;
    }
    try{
    let scrollHeight , clientHeight;
    let multiLineCellValue = document.querySelector(".ag-cell-focus .multiLineCell");
    params.store.currentCommentsElement = multiLineCellValue;
    scrollHeight = multiLineCellValue.scrollHeight;
    clientHeight = multiLineCellValue.clientHeight;
    const isOverflowing = scrollHeight > clientHeight && scrollHeight > 180;
    const viewMoreTextElement = multiLineCellValue.querySelector('.viewMoreText');
    if (viewMoreTextElement) {
      if (isOverflowing) {
        viewMoreTextElement.style.display = "block";
      } else {
        viewMoreTextElement.style.display = "none";
      }
    }
    }
    catch(e){
      console.log(e)
    }
  });
  
  x.addEventListener("focusout",function(e){
   if(!params.store.isGridCellEditing){
     const src= e.target;
     src.style.position="absolute";
     src.style.bottom="";
    }})
  // Within the default multiline code
  return (
    '<div\
      class="multiLineCell'+ (params.node.rowHeight <= DIMENSIONS.cell_height_compact
            ? " multiLineCompactCell"
            : "") +'"\
      style="width: ' + (widthOfCell - 15) + 'px; height: '+ params.node.rowHeight +'px;\
      padding-top: \
      '+ (params.node.rowHeight <= DIMENSIONS.cell_height_compact
        ? "12px"
        : params.node.rowHeight <= DIMENSIONS.cell_height_short
          ? "0px"
          : "10px") +';\
      line-height: \
      '+ (params.node.rowHeight <= DIMENSIONS.cell_height_compact
        ? "normal"
        : "") +';"\
    >\
      <div\
        class="'+ (params.node.rowHeight <= DIMENSIONS.cell_height_compact
            ? "multiLineCompactCellValueContainer"
            : "multiLineCellValueContainer") +'"\
        style="width: ' + (widthOfCell - 25) + 'px;"\
      >'+(params.node.rowHeight <= DIMENSIONS.cell_height_compact 
        ? '<div\
          class="multiLineCompactCellValueContainer multiLineCellValue"\
            style="width: ' + (widthOfCell - 25) + 'px; min-height: '+ (params.node.rowHeight-22) +'px;\
            white-space:\
              ' + (params.node.rowHeight <= DIMENSIONS.cell_height_short
                ? "nowrap"
                : "pre-wrap") + ';\
            -webkit-line-clamp: '+numberOfRows+';\
            display: '+display+';"\
        >'+renderTextValue(commentsArray)+'</div>' 
        : '\
        <div\
          class="multiLineCellValueContainer multiLineCellValue"\
            style="width: ' + (widthOfCell - 25) + 'px; min-height: '+ (params.node.rowHeight-22) +'px;\
            white-space:\
              ' + (params.node.rowHeight <= DIMENSIONS.cell_height_short
                ? "nowrap"
                : "pre-wrap") + ' ;\
            -webkit-line-clamp: '+numberOfRows+';\
            display: '+display+';"\
        >'+renderTextValue(commentsArray)+'</div>')+'\
      </div>\
  <div class="viewMoreText" style="color:#a7a7a7; font-weight: 500; font-family: Roboto, SF-Pro-Text-Regular; margin-top: -10px; display: none; margin-bottom: -15px;">\<span style="display: block; margin-bottom: 1px;color: black;">...</span>Double click to view more</div>\
    </div>'
  );
  
}
export function renderTextValue(commentsArray) {
  var val = commentsArray.join('<br>');
  if (
    val.match(
      /^(([^<>()\[\]\\.,;\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  ) {
    return val.replace(
      /^(([^<>()\[\]\\.,;\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      function (url) {
        var urlHref;
        if (
          url.match(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ) {
          urlHref = "mailto:" + url;
        }
        return '<a href="' + urlHref + '" target="_blank">' + url + "</a>";
      }
    );
  } else {
    return val.replace(
      /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=\]\[]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=\]\[]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.|([a-zA-Z]*[0-9]*\@))+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\]\[\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi,
      function (url) {
        var urlHref;
        if (
          url.match(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ) {
          urlHref = "mailto:" + url;
        } else if (!url.match(/^[a-zA-Z]+:\/\//)) {
          urlHref = "http://" + url;
        } else {
          urlHref = url;
        }
        return '<a href="' + urlHref + '" target="_blank">' + url + "</a>";
      }
    );
  }
}
